export default {
  a: 'A',
  b: 'B',
  c: 'C',
  d: 'D',
}